import { render, staticRenderFns } from "./r-radio.vue?vue&type=template&id=687dc8e0&scoped=true"
import script from "./r-radio.vue?vue&type=script&lang=js"
export * from "./r-radio.vue?vue&type=script&lang=js"
import style0 from "./r-radio.vue?vue&type=style&index=0&id=687dc8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687dc8e0",
  null
  
)

export default component.exports